import { ActionType } from '../../../stores/action-types';
import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import React, { useCallback, ChangeEvent } from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { addUsersToSystemGroup } from '../../../stores/actions/installerActions';
import { getSystemGroups } from '../../../stores/actions/dashboardActions';
import { getUsersForSystemGroup } from '../../../stores/actions/actions';
import { connect } from 'react-redux';
import Snackbar from '../../../../components/Snackbar/Snackbar';
import Person from '@material-ui/icons/Person';
import utils from '../../../helpers/GlobalVariables';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { PickList } from 'primereact/picklist';
import '../InstallerPanel.css';

interface IAddSystemsToGroupProps {
    systemGroups: any[];
    accountsForGroup: any[];
    classes: ClassNameMap;
    addUsersToSystemGroupFailed: boolean;
    addUsersToSystemGroupSucceeded: boolean;
    disableRefreshButton: boolean;
    emptySystem: boolean;
    getSystemGroups: () => void;
    getUsersForSystemGroup: (groupID) => void;
    mobileView: boolean;
    addUsersToSystemGroup: (accID, systemIDs) => void;
    accounts: any[];
}

const AddUsersToSystemGroup = ({
    systemGroups,
    accountsForGroup,
    addUsersToSystemGroupFailed,
    addUsersToSystemGroupSucceeded,
    disableRefreshButton,
    emptySystem,
    getSystemGroups,
    getUsersForSystemGroup,
    mobileView,
    addUsersToSystemGroup,
    accounts,
    ...props
}: IAddSystemsToGroupProps) => {
    const { classes } = props;
    const [error, setError] = useState<boolean>(false)
	const [pickedAccounts, setPickedAccounts] = useState([]);
    const [pickedGroup, setPickedGroup] = useState<string>("");
    const [allAccounts, setAllAccounts] = useState([]);
    const [privateGroups, setPrivateGroups] = useState([]);
    const [nonEditableAccountsTarget, setNonEditableAccountsTarget] = useState([]);
    const [nonEditableAccountsSource, setNonEditableAccountsSource] = useState([]);
    const dispatch = useDispatch();
    const closeNotificationTimer = useRef(null);
    const [emptySystemError, setEmptySystemError] = useState<boolean>(false);
    const systemGroupOptions = privateGroups ? privateGroups
        .sort((a, b) => (a.name > b.name) ? 1 : -1)
        .map((group) => group.name) : [];
        

    const closeAddSystemsToGroupNotification = useCallback(() => {
        dispatch({ type: ActionType.CLOSE_ADD_ACCOUNTS_TO_SYSTEM_GROUP_NOTIFICATION });
    }, [dispatch]);

    useEffect(() => {
        closeAddSystemsToGroupNotification();
        setEmptySystemError(false);
    }, [closeAddSystemsToGroupNotification, setEmptySystemError]);

    useEffect(() => {
        getSystemGroups();
    }, [getSystemGroups]);


    useEffect(() => {
        if (systemGroups !== undefined) {
            setPrivateGroups([...systemGroups].filter(g => g.isPublic == false));
        }
    }, [systemGroups]);

    useEffect(() => {
        if (addUsersToSystemGroupFailed || addUsersToSystemGroupSucceeded) {
            closeNotificationTimer.current = setTimeout(closeAddSystemsToGroupNotification, 6000);
        }
        if (emptySystemError) {
            closeNotificationTimer.current = setTimeout(() => {
                setEmptySystemError(false);
            }, 6000);
        }
        return () => {
            clearTimeout(closeNotificationTimer.current);
        };
    }, [closeAddSystemsToGroupNotification, addUsersToSystemGroupFailed, addUsersToSystemGroupSucceeded, emptySystemError]);

    useEffect(() => {
        if (accountsForGroup && accounts) {
            const allAccounts = [...accounts].filter(a => !accountsForGroup.map(b=>b.id).includes(a.id));
            const nonEditableAccounts = [...allAccounts].filter(a => a.accessRightToAccount.String === 'read_only');
            setAllAccounts(allAccounts);
            setNonEditableAccountsSource(nonEditableAccounts);
        }
    }, [accounts, accountsForGroup]);

    useEffect(() => {
        if (pickedGroup) {
            const nonEditableAccounts = [...accountsForGroup].filter(a => a.accessRightToAccount.String === 'read_only');
            setPickedAccounts(accountsForGroup);
            setNonEditableAccountsTarget(nonEditableAccounts);
        }
    }, [accountsForGroup]);


    useEffect(() => {
        const systemIdsByNames = Object.fromEntries(privateGroups.map(x => [x.name, x.ID]));
        const id = systemIdsByNames[pickedGroup];
        if (id) {
            getUsersForSystemGroup(systemIdsByNames[pickedGroup]);
        }
    }, [pickedGroup]);

    const handlePickGroup = (e: ChangeEvent<{ value: unknown }>, selected: string): void => {
        if (selected !== null && selected !== "") {
            setPickedGroup(selected);
        } else {
            setPickedGroup("")
        }
    };

    const handleAddUsersToSystemGroup = (): void => {
        if (pickedGroup !== "" && pickedAccounts?.length) {
            const pickedAccountsIds = pickedAccounts.map(account => account.id);
            const groupID = privateGroups.filter((group) => group.name === pickedGroup)[0].ID;
            addUsersToSystemGroup(groupID, pickedAccountsIds)
        }
    }
    const mergeById = (target, source) => {
        source.forEach(sourceElement => {
          let targetElement = target.find(targetElement => {
            return sourceElement['id'] === targetElement['id'];
          })
          targetElement ? Object.assign(targetElement, sourceElement) : target.push(sourceElement);
        })
    };

    const onChange = (event) => {
        let picked = [...event.target];
        let all = [...event.source];

        mergeById(picked, nonEditableAccountsTarget);
        picked = picked.filter(a => !nonEditableAccountsSource.some(b => b.id === a.id));
        mergeById(all, nonEditableAccountsSource);
        all =  all.filter(a => !nonEditableAccountsTarget.some(b => b.id === a.id));
        setAllAccounts(all.sort((a, b) => (a.name > b.name) ? 1 : -1));
        setPickedAccounts(picked.sort((a, b) => (a.name > b.name) ? 1 : -1));
    };

    const itemTemplate = (account) => {
        let wasInGroup = false;
        let nonEditable = false;
        if (account.accessRightToAccount.String === 'read_only') {
            nonEditable = true;
        }

        accountsForGroup.forEach((a) => {
            if (a.id === account.id) {
                wasInGroup = true;
            }
        });

        return (
            <div 
              style={{backgroundColor: !wasInGroup && pickedGroup && !nonEditable ? 'floralwhite' : 'transparent', opacity: nonEditable ? '50%' : '100%', flexDirection: 'column' }} 
              className="flex flex-wrap p-2 gap-3">
                <span>{account.name}</span>
                <span>{account.email}</span>
            </div>
        );
    };

    const pinButton = (): JSX.Element => {
        return (
            <Button
                size='medium'
                style={{ marginTop: error ? '5px' : '25px', transition: 'color 0.3s' }}
                disabled={pickedGroup === "" || !pickedAccounts?.length}
                data-testid='addUsersToSystemGroup'
                onClick={(e) => { handleAddUsersToSystemGroup() }}
            >
                Save
            </Button>
        );
    };

    const renderMobileNotifications = (): JSX.Element => {
        const error = addUsersToSystemGroupFailed || emptySystemError;
        const headerStyle = utils.getHeaderStyle(error);

        if (!mobileView) return null;
        if (error || addUsersToSystemGroupSucceeded) {
            const className = error ? 'notification-open-create-account-fail' : 'notification-open-create-account-success';
            return (
                <h5 className={className} style={headerStyle}>
                    {addUsersToSystemGroupFailed
                        ? 'Could not save system group.' 
                        : 'System group saved successfully.'}
                </h5>
            );
        }
        return <div style={utils.emptyHeaderStyle}></div>;
    };

    if (accounts.length < 1) {
        return (
            <Card>
                <CardHeader color='info' icon>
                    <CardIcon color='info'>
                        <Person />
                    </CardIcon>
                    <h4 data-testid='addSystemsToGroupHeader' className={classes.cardIconTitle}>
                        Modify System Group Access
                    </h4>
                </CardHeader>
                <CardBody>No accounts.</CardBody>
            </Card>
        );
    }

    return (
        <Card className='addSystemsToGroupForm'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <Person />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Add/Remove Accounts (Private Groups)</h4>
            </CardHeader>
            <CardBody>
                <FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()}>
                    <div style={{ width: '100%' }}>
                        <Autocomplete
                            options={systemGroupOptions}
                            getOptionLabel={(group) => group}
                            id='group-name'
                            value={pickedGroup}
                            onChange={(event, newValue) => handlePickGroup(event, newValue)}
                            renderInput={(privateGroups) => <TextField {...privateGroups} label='System Groups' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                    </div>
                </FormControl>
                <div className="card" style={{marginTop: '10px'}} hidden={!pickedGroup}>
                    <PickList dataKey="id" source={allAccounts} target={pickedAccounts} onChange={onChange} itemTemplate={itemTemplate} filter filterBy="name,email" breakpoint="1280px"
                        sourceHeader="Available" targetHeader="Selected" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
                        sourceFilterPlaceholder="Search by name" targetFilterPlaceholder="Search by name" autoOptionFocus={false} 
                        showSourceControls={false} showTargetControls={false} />
                </div>
                {renderMobileNotifications()}
                {pinButton()}
            </CardBody>
            {!mobileView ? (
                <>
                    <Snackbar
                        close
                        closeNotification={() => closeAddSystemsToGroupNotification()}
                        color={addUsersToSystemGroupFailed ? 'danger' : 'success'}
                        message={addUsersToSystemGroupFailed ? 'Could not save system group.' : 'System group saved successfully.'}
                        open={addUsersToSystemGroupFailed || addUsersToSystemGroupSucceeded}
                        place='tc'
                    />
                </>
            ) : null}
        </Card>
    );
};

const mapStateToProps = (state) => ({
    systemGroups: state.installer.systemGroups,
    accountsForGroup: state.dashboard.accountsForGroup,
    addUsersToSystemGroupFailed: state.dashboard.addUsersToSystemGroupFailed,
    addUsersToSystemGroupSucceeded: state.dashboard.addUsersToSystemGroupSucceeded,
    emptySystem: state.dashboard.emptySystem,
    mobileView: state.dashboard.mobileView,
});
const actions = {
    getSystemGroups,
    addUsersToSystemGroup,
    getUsersForSystemGroup
};

const AddSystemsToGroupWithStyles = regularFormsStyle(AddUsersToSystemGroup);
export default connect(mapStateToProps, actions)(AddSystemsToGroupWithStyles);
